import { Component } from '@angular/core';

@Component({
    selector: 'app-account-change-log',
    templateUrl: './account-change-log.component.html',
    styleUrl: './account-change-log.component.scss',
    standalone: true,
    imports: []
})
export class AccountChangeLogComponent {

}
